export default __webpack_public_path__ + "static/media/logoColored.e65ea8e9.png";